import $ from 'jquery';

export default () => {
    $('ul.menu li.menu-item-has-children > a').on('click', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var a = $(this);
        var content = $(this).parent().find('ul.sub-menu');
        if ($(a).attr('class') != 'active') {
            $(content).slideUp();
            $(a).next().slideToggle();
            $(content).removeClass('active');
            $(a).addClass('active');
        } else {
            $(content).slideUp();
            $(a).removeClass('active');
        }
    })

};



// WEBPACK FOOTER //
// ../views/menu/menu-accordion.js